import { Component } from 'angular-ts-decorators';

import { AppComponent } from '@classes/app-component';

import { CookieStreams } from '@shared/app/scripts/services/cookie-streams';
import { CurrentSession } from '@shared/app/scripts/services/current-session';
import { Domain } from '@shared/app/scripts/services/domain';
import { RouteParamsStreams } from '@core/app/scripts/services/route-params-streams';
import { Session } from '@shared/app/scripts/services/session';
import { SettingsManager } from '@shared/app/scripts/services/settings-manager';
import { SidAutoRedirect } from '@core/app/scripts/services/sid-auto-redirect';

/**
 * Root component for loginApp app. Loads all necessary data & notify the user
 * about any possible issue.
 *
 * Inherits form {@link coreModule.AppComponent}.
 */
@Component({
  selector: 'loginApp',
  template: require('./login-app.html').default,
})
export class LoginAppComponent extends AppComponent {
  constructor(
    $element: ng.IAugmentedJQuery,
    $q: ng.IQService,
    $window: ng.IWindowService,
    cookieStreams: CookieStreams,
    currentSession: CurrentSession,
    domain: Domain,
    routeParamsStreams: RouteParamsStreams,
    session: Session,
    settingsManager: SettingsManager,
    sidAutoRedirect: SidAutoRedirect,
  ) {
    'ngInject';
    super(
      $element,
      $window,
      routeParamsStreams,
      $q,
      cookieStreams,
      currentSession,
      domain,
      session,
      settingsManager,
      sidAutoRedirect,
    );
  }

  // hacky - overrides parent method, to inject optimistic promises
  // TODO cover with unit test
  getPromise(name): ng.IPromise<void> {
    return super.getPromise(name).catch(angular.noop);
  }
}
